import client from "./base"

export const getAbnormalPriceProduct = async (params: any) => {
    const { adminId, abnormalRatio, area, limit, offset } = params

    let path = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/pis/inventory-management/admins/${adminId}/product-stats/abnormal-price?abnormalRatio=${abnormalRatio}&limit=${limit}&offset=${offset}`

    if (area) {
        path += `&area=${area}`
    }

    try {
        let fetchResults = await client.get(path)
        let data: any = fetchResults.data
        return {
            data
        }
    } catch (err) {
        console.error("error on fetch inv items: ", err);
        return {
            data: []
        }
    }
}

export const getAbnormalPriceProductCount = async (params: any) => {
    const { adminId, abnormalRatio, area } = params

    let path = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/pis/inventory-management/admins/${adminId}/product-stats/abnormal-price/count?abnormalRatio=${abnormalRatio}`
    if (area) {
        path += `&area=${area}`
    }

    try {
        let fetchResults = await client.get(path)
        let data: any = fetchResults.data
        return {
            data
        }
    } catch (err) {
        console.error("error on fetch inv items: ", err);
        return {
            data: {}
        }
    }
}

export const exportAbnormalPriceProducts = async (params: any) => {
    const { adminId, abnormalRatio, area } = params;

    let path = `${process.env.REACT_APP_PHARMACY_INVENTORY_API_BASE_URL}/pis/inventory-management/admins/${adminId}/product-stats/abnormal-price/export?abnormalRatio=${abnormalRatio}`;
    if (area) {
        path += `&area=${area}`;
    }

    try {
        const response = await client.get(path, {
            responseType: 'blob',
        });

        const contentType = response.headers['content-type'];

        if (contentType.includes('application/json')) {
            const text = await response.data.text();
            const json = JSON.parse(text);
            return {
                success: true,
                waiting: true,
                message: json.message || 'Đang xử lý dữ liệu...',
            };
        }

        // Nếu là file CSV
        const disposition = response.headers['content-disposition'];
        let filename = `abnormal-products-${Date.now()}.csv`;
        if (disposition && disposition.includes('filename=')) {
            filename = disposition.split('filename=')[1].replace(/"/g, '').trim();
        }

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.remove();

        return { success: true, downloaded: true };
    } catch (err: any) {
        if (err.response && err.response.data) {
            try {
                const text = await err.response.data.text();
                const json = JSON.parse(text);
                return {
                    success: false,
                    message: json.message || 'Có lỗi xảy ra!',
                };
            } catch (parseError) {
                return {
                    success: false,
                    message: 'Lỗi không xác định từ server.',
                };
            }
        }

        return {
            success: false,
            message: 'Không thể kết nối đến server.',
        };
    }
};

